const COMPOSER_IFRAME_SELECTOR = 'iframe.composer-iframe';
export function isEditorInIframe(editorView) {
  return editorView.dom.ownerDocument !== document;
}
export function isElementInEditorDocument(element, editorView) {
  return editorView.dom.ownerDocument === element.ownerDocument;
}
export function findIframeForEditor(editorView) {
  let iframes = Array.from(document.querySelectorAll(COMPOSER_IFRAME_SELECTOR));
  return iframes.find(iframe => {
    return iframe.contentDocument === editorView.dom.ownerDocument;
  });
}
export function adjustForIframeIfNecessary(rect, editorView) {
  if (!isEditorInIframe(editorView)) {
    // If the editor view is owned by the window's document, it must not be inside an iFrame.
    return rect;
  }
  let composerIframe = findIframeForEditor(editorView);
  if (!composerIframe) {
    return rect;
  }
  let iframeRect = composerIframe.getBoundingClientRect();
  let x = rect.x + iframeRect.x;
  let y = rect.y + iframeRect.y;
  return new DOMRect(x, y, rect.width, rect.height);
}